import { MIN_POSITION, MAX_POSITION } from '../constants';

/**
 * Restricts value to the slider range 0..100.
 */
export function clampPosition(value) {
  return Math.min(MAX_POSITION, Math.max(MIN_POSITION, value));
}
